import { useTranslation } from 'react-i18next';
import { LazyLoadImage } from "react-lazy-load-image-component";
import 'react-lazy-load-image-component/src/effects/blur.css';
import { BlurText, FadeContent } from "../Compartido/EfectesFonts";
import limpiarHtml from "../Compartido/limpiarHtml.js";
import '../../../../../css/web/bedloop1/destacados.css';

// Amb una sola propietat destacada la secció quedava amb una targeta
// petita i sola al mig: en lloc d'això es mostra una fitxa ampla amb una
// graella "bento" de les fotos web i les dades principals al costat.
const DestacadoUnico = ({ ruta, propiedad, config, lang }) => {

    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    const href = "/" + preidioma + t("apartamentos") + "-" + propiedad.url_destino + "/" + propiedad.url_dinamica;

    const fotosOrigen = (propiedad.fotos_web && propiedad.fotos_web.length) ? propiedad.fotos_web : (propiedad.foto_principal || []);
    // 5 omplen la graella sencera; amb 3 o 4 es fa servir la de 3 (sense forats)
    const numFotos = fotosOrigen.length >= 5 ? 5 : (fotosOrigen.length >= 3 ? 3 : fotosOrigen.length);
    const fotos = fotosOrigen.slice(0, numFotos);
    const fotosRestants = fotosOrigen.length - numFotos;

    const descripcion = propiedad.ladesccorta ? limpiarHtml(propiedad.ladesccorta) : "";

    return (
        <FadeContent blur={true} duration={200} easing="ease-out" initialOpacity={0} className="bl1-unica">
            <div className={"bl1-unica__galeria bl1-unica__galeria--n" + Math.max(numFotos, 1)}>
                {
                    fotos.length != 0
                        ? fotos.map((foto, index) => (
                            <a href={href} className={"bl1-unica__foto" + (index == fotos.length - 1 && fotosRestants > 0 ? " bl1-unica__foto--mes" : "")} key={foto.id ?? index}>
                                <LazyLoadImage effect='blur' threshold={10} src={ruta + "/propiedades/" + propiedad.id + "/fotos/web/" + foto.nombre} alt={foto.texto_alt ? foto.texto_alt[lang] : ""} title={foto.texto_title ? foto.texto_title[lang] : ""} />
                                {index == fotos.length - 1 && fotosRestants > 0 &&
                                    <span className="sobreimagen bl1-unica__mes">
                                        <span className="bl1-unica__mes-numero">+{fotosRestants}</span>
                                        {t("Ver todas las fotos")}
                                    </span>
                                }
                            </a>
                        ))
                        : <a href={href} className="bl1-unica__foto">
                            <LazyLoadImage effect='blur' threshold={10} src="/images/web/bedloop-nofoto.png" alt="" title="" />
                        </a>
                }
            </div>

            <div className="bl1-unica__info">
                <div className="bl1-unica__intro">
                    {propiedad.ciudad && <span className="bl1-unica__ciutat">{propiedad.ciudad}</span>}
                    <h3 className="bl1-unica__titol"><a href={href}>{propiedad.nombre}</a></h3>
                    {descripcion && <div className="bl1-unica__desc" dangerouslySetInnerHTML={{ __html: descripcion }}></div>}
                </div>

                <div className="bl1-unica__accio">
                    <dl className="bl1-unica__dades">
                        <div>
                            <dt><i className="fa-solid fa-bed"></i> {t("Habitaciones")}</dt>
                            <dd>{propiedad.num_habitaciones}</dd>
                        </div>
                        <div>
                            <dt><i className="fa-solid fa-users"></i> {t("Huéspedes")}</dt>
                            <dd>{propiedad.capacidad_maxima}</dd>
                        </div>
                        <div>
                            <dt><i className="fa-solid fa-bath"></i> {t("Baños")}</dt>
                            <dd>{propiedad.num_banyos}</dd>
                        </div>
                        {propiedad.metros_cuadrados > 0 &&
                            <div>
                                <dt><i className="fa-solid fa-ruler-combined"></i> m²</dt>
                                <dd>{propiedad.metros_cuadrados}</dd>
                            </div>
                        }
                    </dl>

                    <a className="btn btn-primary bl1-unica__cta" href={href} style={{ background: "" + config.color_corporativo_web + "", border: "1px solid" + config.color_corporativo_web }}>
                        {
                            propiedad.by_request == 1
                                ? t("Petición")
                                : t("Reservar")
                        }
                    </a>
                </div>
            </div>
        </FadeContent>
    );
};

const ListaDestacados = ({ ruta, destacadas, config, lang, ambDescripcio = false }) => {

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    const { t } = useTranslation();

    let results = [];

    {/* ************* */ }

    return (
        <>
            {destacadas.forEach((propiedad, index) => {
                results = results.concat(
                    <div className="destacats-propietat" key={index}>
                        <FadeContent blur={true} duration={200} easing="ease-out" initialOpacity={0}>
                            <a href={"/" + preidioma + t("apartamentos") + "-" + propiedad.url_destino + "/" + propiedad.url_dinamica}>
                                {
                                    propiedad.foto_principal.length != 0
                                        ? <LazyLoadImage effect='blur' threshold={10} className="destacats-imatge-propietat" src={ruta + "/propiedades/" + propiedad.id + "/fotos/web/" + propiedad.foto_principal[0].nombre} alt={propiedad.foto_principal[0].texto_alt ? propiedad.foto_principal[0].texto_alt[lang] : ""} title={propiedad.foto_principal[0].texto_title ? propiedad.foto_principal[0].texto_title[lang] : ""} />
                                        : <LazyLoadImage effect='blur' threshold={10} className="destacats-imatge-propietat" src="/images/web/bedloop-nofoto.png" alt="" title="" />
                                }
                            </a>
                            <div className="destacats-text">
                                <span className="destacats-icones-propietat" style={{ color: "" + config.color_corporativo_web + "" }}>
                                    <i className="fa-solid fa-bed"></i> {propiedad['num_habitaciones']} | <i className="fa-solid fa-users"></i> {propiedad['capacidad_maxima']} | <i className="fa-solid fa-bath"></i> {propiedad['num_banyos']}
                                </span>
                                <span className="destacats-titol-propietat"><a href={"/" + preidioma + t("apartamentos") + "-" + propiedad.url_destino + "/" + propiedad.url_dinamica}>{propiedad.nombre}</a></span>
                                <span className="destacats-ciutat-propietat"> {propiedad.ciudad}</span>
                                {ambDescripcio && propiedad.ladesccorta &&
                                    <div className="destacats-desc-propietat" dangerouslySetInnerHTML={{ __html: limpiarHtml(propiedad.ladesccorta) }}></div>
                                }
                                <a className="btn btn-primary" href={"/" + preidioma + t("apartamentos") + "-" + propiedad.url_destino + "/" + propiedad.url_dinamica} style={{ background: "" + config.color_corporativo_web + "", border: "1px solid" + config.color_corporativo_web, float: "right" }}>
                                    {
                                        propiedad.by_request == 1
                                            ? t("Petición")
                                            : t("Reservar")
                                    }
                                </a>
                            </div>
                        </FadeContent>
                    </div>
                )
            })}

            {results}
        </>
    );
};

const Destacados = ({ destinos, ruta, destacadas, elementosweb, config, lang }) => {

    const { t } = useTranslation();


    return (

        <div className="pt-5 fons potblur">
            {elementosweb.subtitulo_buscador && <h2 className="mb-5 text-center">
                <BlurText
                    text={elementosweb.subtitulo_buscador[lang]}
                    delay={150}
                    animateBy="words"
                    direction="top"
                />
            </h2>}
            {elementosweb.subtitulo_propiedades && <h3 className="text-center">
                <BlurText
                    text={elementosweb.subtitulo_propiedades[lang]}
                    delay={150}
                    animateBy="words"
                    direction="bottom"
                />

            </h3>}



            {destacadas.length == 1 ? (
                <DestacadoUnico
                    ruta={ruta}
                    propiedad={destacadas[0]}
                    config={config}
                    lang={lang}
                />
            ) : (
                <div className={"destacats" + (destacadas.length == 2 || destacadas.length == 3 ? " destacats--pocas destacats--n" + destacadas.length : "")}>
                    <ListaDestacados
                        ruta={ruta}
                        destacadas={destacadas}
                        config={config}
                        lang={lang}
                        ambDescripcio={destacadas.length == 2 || destacadas.length == 3}
                    />
                </div>
            )}
        </div>
    );
};

export default Destacados;
